(() => {
	document.addEventListener("DOMContentLoaded", () => {
		const freshChatScript = [freshChatAssetUrl];
		let freshChatAdded = false;

		const addScriptTagsToHeader = (scripts, module, callback) => {
			const scriptPromises = scripts.map((scriptPath) => {
				return new Promise((resolve, reject) => {
					const script = document.createElement("script");
					script.src = scriptPath;

					if (module) script.type = "module";

					script.onload = resolve;
					script.onerror = reject;
					document.head.appendChild(script);
				});
			});

			Promise.all(scriptPromises)
				.then(callback)
				.catch((error) => console.error("Error loading script:", error));
		};

		const addScripts = (scriptFlag, scriptSrc, module) => {
			if (!scriptFlag) {
				addScriptTagsToHeader(scriptSrc, module, () => {
					scriptFlag = true;
				});
			}
		};

		const addScriptsOnce = () => {
			addScripts(freshChatAdded,freshChatScript, false);

			window.removeEventListener("click", addScriptsOnce);
			window.removeEventListener("mousemove", addScriptsOnce);
			window.removeEventListener("scroll", addScriptsOnce);
			window.removeEventListener("touchstart", addScriptsOnce);
		};

		window.addEventListener("click", addScriptsOnce);
		window.addEventListener("mousemove", addScriptsOnce);
		window.addEventListener("scroll", addScriptsOnce);
		window.addEventListener("touchstart", addScriptsOnce);
	});
})();
